
const allCharacters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
export default class StringUtil {
  static randomString(length: number = 8) {
    let result = '';
    const charactersLength = allCharacters.length;
    let counter = 0;
    while (counter < length) {
      result += allCharacters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  }

  /**
   *
   * @param someStr {string}
   * @return NaN if not found
   */
  getFirstNumber(someStr: string): Number {
    let firstNumCharAt = -1;
    let num = NaN;
    let subString: string = '';
    let subStringAsNum: number = NaN;
    let c: string = '';

    for (let i = 0; i < someStr.length; i++) {
      c = someStr[i];

      if (firstNumCharAt === -1) {
        if (c >= '0' && c <= '9') {
          firstNumCharAt = i;
        }
        continue;
      }
      subString = someStr.substring(firstNumCharAt, i + 1);
      subStringAsNum = Number(subString);
      if (!isNaN(subStringAsNum)) {
        num = subStringAsNum;
        continue;
      }
      break;
    }
    return num;
  }

}
